export const CONTEXT = {
  MODAL: 'MODAL',
  BLADE: 'BLADE',
  SHEET: 'SHEET'
};